import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { digObject } from '@domain-group/javascript-utils'

import {
  Button, ModalContext, SectionDivider, SidebarModal,
} from '@domain-group/suit-theme'

import EntitySelector from '@components/EntitySelector'
import PublicationListItem from '@components/PublicationListItem'

import useManageServiceProductPublicationsModal from './hooks/useManageServiceProductPublicationsModal'

const confirmSave = (entityState, callbacks, updateFn) => {
  const { closeModal, updateServiceProduct } = callbacks || {}

  const serviceProductPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Publications Updated',
  }

  swal
    .fire({
      confirmButtonColor: '#43ac6a',
      confirmButtonText: 'Yes, enable them.',
      icon: 'success',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Enable Publications?',
    })
    .then(({ value }) => {
      if (value){
        updateServiceProduct(serviceProductPayload)
      }
    })
}

const ManageServiceProductPublicationsModal = (props) => {
  const { callbacks, modalKey, showModal } = props

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { serviceProduct, optionsKey } = modalPayload

  const {
    callbacks: {
      togglePublicationId,
      updateServiceProduct: updateFn,
    },
    hasSelectedPublications,
    selectedPublicationIds,
    serviceProductParams,
    sortedPublications,
  } = useManageServiceProductPublicationsModal(serviceProduct, optionsKey)

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Manage" titleSecondLine="Publications" />

      <SidebarModal.Content>
        <EntitySelector
          callbacks={{ selectItem: publication => togglePublicationId(publication?.id) }}
          entityKey="publications"
          label="* Add Publication"
          requestOptions={{ include_publication_provider: true }}
          selectedIds={selectedPublicationIds}
          showSelectedEntity={false}
        />

        {hasSelectedPublications && (
          <>
            <SectionDivider marginTop="large">Selected</SectionDivider>

            {sortedPublications.map(publication => (
              <PublicationListItem
                callbacks={{
                  togglePublicationId: () => togglePublicationId(publication.id),
                }}
                key={publication.id}
                publication={publication}
              />
            ))}
          </>
        )}

      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          onClick={() => confirmSave(serviceProductParams, callbacks, updateFn)}
          size="large"
        >
          Enable Publications
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

ManageServiceProductPublicationsModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

ManageServiceProductPublicationsModal.defaultProps = {
  modalKey: 'ManageServiceProductPublicationsModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <ManageServiceProductPublicationsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
